/** Shared layout tokens for floating bottom nav + safe area (CSS vars in index.css). */
export const BOTTOM_NAV_OFFSET = 'var(--app-bottom-nav-offset)';
export const SCROLL_PAD_BOTTOM = 'var(--app-scroll-pad-bottom)';

/** Scroll padding under cart list (compact pill / expanded form / hidden). */
export const cartScrollPadHidden = 'var(--app-scroll-pad-bottom)';
export const cartScrollPadCompact = 'var(--app-scroll-pad-cart-compact)';
export const cartScrollPadExpanded = 'var(--app-scroll-pad-cart-expanded)';
